import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Wrapper, Title, Description, Prompt } from './styled';
import { speedAnimation } from '~/src/components/QuizGame/Quiz/styled';

const Texts = ({ stepQuiz, questions, showTariff, textsForTariff, isSended, isSendError, name }) => {
    const [isShowTariff, setIsShowTariff] = useState(false);
    useEffect(() => {
        if (showTariff) {
            const timeout = setTimeout(() => {
                setIsShowTariff(true);
                clearTimeout(timeout);
            }, speedAnimation);
        }
    }, [showTariff]);

    if (questions.length === 0) {
 return null;
}

    let prompt = !isShowTariff ? `Вопрос ${stepQuiz + 1}/${questions.length}` : 'Вот так результат! ';
    let title = !isShowTariff ? questions[stepQuiz].title : textsForTariff.title;
    let description = !isShowTariff ? questions[stepQuiz].subtitle : textsForTariff.description;

    if (isSended) {
        prompt = '';
        title = `${name}, ваша заявка принята`;
        description = `
            <ol>
                <li>Вам позвонит менеджер, чтобы уточнить удобную дату и время визита техника.</li>
                <li>Техник привезет вам договор и настроит оборудование.</li>
            </ol>            
        `;
    }

    if (isSendError) {
        prompt = '';
        title = 'Произошла ошибка';
        description = 'Чтобы оформить заявку на подключение напишите в чат.';
    }

    return (
        <Wrapper>
            {prompt && <Prompt>{prompt}</Prompt>}
            <Title>{title}</Title>
            <Description dangerouslySetInnerHTML={{ __html: description }} />
        </Wrapper>
    );
};

Texts.defaultProps = {
    showTariff: false,
    stepQuiz: 0,
    questions: [],
    textsForTariff: { title: '', description: '' },
    name: ''
};

const mapStateToProps = state => ({
    showTariff: state.quiz.showTariff,
    stepQuiz: state.quiz.stepQuiz,
    questions: state.quiz.questions,
    isSended: state.quiz.isSended,
    isSendError: state.quiz.isSendError,
    name: state.quiz.name
});

export default connect(mapStateToProps)(Texts);
